const MENTEE_EXPECTATIONS: Record<string, string> = {
  CONFIDENCE: 'Gagner en confiance',
  NETWORK: 'Un réseau, de nouveaux contacts',
  ENCOURAGEMENT: 'Être encouragé dans mes démarches',
  REFLECTION: 'Me questionner, prendre du recul',
};

export type MenteeExpectationValues = keyof typeof MENTEE_EXPECTATIONS;
export const menteeExpectations = Object.keys(MENTEE_EXPECTATIONS) as MenteeExpectationValues[];

export default MENTEE_EXPECTATIONS;